import React, { useState, useEffect } from "react";
import { Button, Form, FormGroup, Input, Label, Alert } from "reactstrap";
import axios from "axios";
import Select from "react-select"; // Import react-select
import { API_URL_proyectos, API_URL_batch_proyectos } from "../../constants";

import { getAuthHeaders } from "../../utils/auth";
const NewBatchProyectoForm = ({ toggle, resetState, batch }) => {
  const [projects, setProjects] = useState([]); // All available projects
  const [batchProjects, setBatchProjects] = useState([]); // Projects selected for the batch
  const [batchName, setBatchName] = useState(""); // Batch Name
  const [remainingPercentage, setRemainingPercentage] = useState(100); // Remaining percentage to allocate
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    const headers = getAuthHeaders();

    // Fetch all available projects
    axios
      .get(API_URL_proyectos, { headers })
      .then((response) => {
        setProjects(response.data.map((p) => ({ value: p.pk, label: p.name }))); // Format projects for react-select
      })
      .catch((error) => {
        console.error("Error fetching projects:", error);
        setErrorMessage("Error fetching projects.");
      });

    // If editing, prepopulate form fields
    if (batch) {
      setBatchName(batch.batch_name);
      setBatchProjects(
        batch.proyectos.map((p) => ({
          proyecto_id: p.proyecto_id,
          revenue_percentage: p.revenue_percentage,
        }))
      );
      recalculateRemainingPercentage(
        batch.proyectos.map((p) => ({
          revenue_percentage: p.revenue_percentage,
        }))
      );
    }
  }, [batch]);

  const addProjectToBatch = () => {
    setBatchProjects([
      ...batchProjects,
      { proyecto_id: null, revenue_percentage: 0 },
    ]);
  };

  const removeProjectFromBatch = (index) => {
    const updatedBatchProjects = batchProjects.filter((_, i) => i !== index);
    setBatchProjects(updatedBatchProjects);
    recalculateRemainingPercentage(updatedBatchProjects);
  };

  const updateBatchProject = (index, field, value) => {
    const updatedBatchProjects = [...batchProjects];
    updatedBatchProjects[index][field] = value;

    if (field === "revenue_percentage") {
      recalculateRemainingPercentage(updatedBatchProjects);
    }

    setBatchProjects(updatedBatchProjects);
  };

  const recalculateRemainingPercentage = (projects) => {
    const totalPercentage = projects.reduce(
      (sum, project) => sum + parseFloat(project.revenue_percentage || 0),
      0
    );
    setRemainingPercentage(100 - totalPercentage);
  };

  const submitBatch = (e) => {
    e.preventDefault();

    const validBatchProjects = batchProjects
      .filter((project) => project.proyecto_id && project.revenue_percentage > 0)
      .map((project) => ({
        proyecto_id: project.proyecto_id,
        revenue_percentage: parseInt(project.revenue_percentage, 10), // Ensure it's an integer
      }));

    const totalPercentage = validBatchProjects.reduce(
      (sum, project) => sum + parseFloat(project.revenue_percentage || 0),
      0
    );

    if (!batchName.trim()) {
      setErrorMessage("Batch name is required.");
      return;
    }

    if (totalPercentage !== 100) {
      setErrorMessage("The total percentage must equal 100%.");
      return;
    }

    if (validBatchProjects.length === 0) {
      setErrorMessage("Please add valid projects to the batch.");
      return;
    }

    const headers = getAuthHeaders();


    const payload = { batch_name: batchName, proyectos: validBatchProjects };
    console.log("Submitting payload:", payload);  
    // Determine if we're creating or updating
    const request = batch
      ? axios.put(`${API_URL_batch_proyectos}${batch.batch_code}/`, payload, {
          headers,
        }) // Update existing batch
      : axios.post(API_URL_batch_proyectos, payload, { headers }); // Create new batch

    request
      .then((response) => {
        console.log("Batch saved successfully:", response.data);
        setSuccessMessage(batch ? "Batch updated successfully." : "Batch created successfully.");
        resetState();
        toggle();
      })
      .catch((error) => {
        console.error("Error saving batch:", error.response || error.message);
        setErrorMessage(
          error.response?.data?.error || "Error saving batch. Please try again."
        );
      });
  };

  return (
    <Form onSubmit={submitBatch}>
      <h4>{batch ? "Editar Bundle" : "Crear Nuevo Bundle"}</h4>
      {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
      {successMessage && <Alert color="success">{successMessage}</Alert>}

      <FormGroup>
        <Label for="batchName">Nombre Bundle</Label>
        <Input
          type="text"
          id="batchName"
          value={batchName}
          onChange={(e) => setBatchName(e.target.value)}
          placeholder="Ingresa nombre de bunlde"
        />
      </FormGroup>

      <FormGroup>
        <Label>Proyectos en Bundle</Label>
        {batchProjects.map((batchProject, index) => (
          <div key={index} className="mb-3">
            <Select
              options={projects}
              value={projects.find(
                (project) => project.value === batchProject.proyecto_id
              )}
              onChange={(selectedOption) =>
                updateBatchProject(index, "proyecto_id", selectedOption.value)
              }
              placeholder="Select a project"
            />
            <Input
              type="number"
              min="0"
              max="100"
              step="1"
              value={batchProject.revenue_percentage}
              placeholder="Revenue Percentage"
              className="mt-2"
              onChange={(e) =>
                updateBatchProject(index, "revenue_percentage", e.target.value)
              }
            />
            <Button
              color="danger"
              size="sm"
              className="mt-2"
              onClick={() => removeProjectFromBatch(index)}
            >
              Remove
            </Button>
          </div>
        ))}
        <Button color="primary" onClick={addProjectToBatch}>
          Add Project
        </Button>
      </FormGroup>

      <p>Remaining Percentage: {remainingPercentage}%</p>
      <Button color="success" disabled={remainingPercentage !== 0}>
        Submit Batch
      </Button>
    </Form>
  );
};

export default NewBatchProyectoForm;